export default "__VITE_ASSET__DpYmVfbr__"